export default "__VITE_ASSET__9yctuSYp__"